import { useState } from 'react';

interface Review {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  time: string;
  content: string;
}

const MOCK_REVIEWS: Review[] = [
  { id: '1', name: 'X*****', avatar: 'X', rating: 5, time: '1天前', content: '查询速度很快，结果准确，非常满意！' },
  { id: '2', name: '唐*', avatar: '唐', rating: 5, time: '1天前', content: '该用户没有填写评价' },
  { id: '3', name: '叶*****', avatar: '叶', rating: 5, time: '1天前', content: '专业可靠，数据真实，推荐使用。' },
  { id: '4', name: 'N**', avatar: 'N', rating: 5, time: '1天前', content: '该用户没有填写评价' },
  { id: '5', name: '5******', avatar: '5', rating: 5, time: '1天前', content: '该用户没有填写评价' },
  { id: '6', name: 'C*******', avatar: 'C', rating: 5, time: '2天前', content: '服务很好，结果详细，值得信赖。' },
  { id: '7', name: '杨**', avatar: '杨', rating: 5, time: '3天前', content: '该用户没有填写评价' },
  { id: '8', name: '付****', avatar: '付', rating: 5, time: '3天前', content: '该用户没有填写评价' },
  { id: '9', name: '谭*', avatar: '谭', rating: 5, time: '4天前', content: '出单很快，2小时内就收到了，满意！' },
  { id: '10', name: '于*', avatar: '于', rating: 5, time: '4天前', content: '该用户没有填写评价' },
];

const FILTER_OPTIONS = ['全部', '5星好评', '4星', '3星', '2星', '1星'];

export default function ReviewList() {
  const [activeFilter, setActiveFilter] = useState('全部');
  const [visibleCount, setVisibleCount] = useState(5);

  const visibleReviews = MOCK_REVIEWS.slice(0, visibleCount);

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-bold text-gray-900">用户评价</h2>
        <div className="flex items-center space-x-1">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-star-fill text-amber-400 text-sm" />
          </div>
          <span className="text-lg font-bold text-gray-900">4.9</span>
          <span className="text-gray-400 text-sm ml-1">(99+)</span>
        </div>
      </div>

      {/* Filter tabs */}
      <div className="flex flex-wrap gap-2 mb-5">
        {FILTER_OPTIONS.map((opt) => (
          <button
            key={opt}
            onClick={() => setActiveFilter(opt)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeFilter === opt
                ? 'bg-gray-900 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>

      {/* Review cards */}
      <div className="space-y-4">
        {visibleReviews.map((review) => (
          <div key={review.id} className="border border-gray-100 rounded-xl p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className="w-9 h-9 flex items-center justify-center bg-gray-200 rounded-full text-sm font-semibold text-gray-700 flex-shrink-0">
                  {review.avatar}
                </div>
                <div>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-900">{review.name}</span>
                    <span className="text-xs text-green-600 bg-green-50 px-1.5 py-0.5 rounded-full">✓ 已购买</span>
                  </div>
                  <span className="text-xs text-gray-400">{review.time}</span>
                </div>
              </div>
              <div className="flex items-center space-x-0.5">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <div key={i} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-xs" />
                  </div>
                ))}
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">{review.content}</p>
          </div>
        ))}
      </div>

      {visibleCount < MOCK_REVIEWS.length && (
        <div className="mt-5 text-center">
          <button
            onClick={() => setVisibleCount((c) => c + 5)}
            className="px-6 py-2.5 border border-gray-200 rounded-xl text-sm text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多评价
          </button>
        </div>
      )}
    </div>
  );
}
